module.exports = __webpack_public_path__ + "static/img/upload01.ae69d55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/upload01.png
// module id = /x+J
// module chunks = 1